/**
 * オブジェクトがすべて合格しているか
 *
 * @param {String} parent 親キー名
 * @param {Object} o チェック対象のオブジェクト
 * @param {Function} fn コールバック関数 (value, name) => boolean
 * @returns {Boolean} すべての要素が合格なら true を返す
 */
function everyObject (parent, o, fn) {
  for (const k in o) {
    const name = !parent ? k : `${parent}.${k}`
    const value = o[k]

    if (typeof value === 'object') {
      if (!everyObject(name, o, fn)) {
        return false
      }
    } else {
      if (!fn(value, name)) {
        return false
      }
    }
  }
  return true
}

/**
 * チェック対象のすべての要素が合格しているか
 *
 * @param {*} o チェック対象
 * @param {Function} fn コールバック関数 (name, value) => boolean
 * @returns {Boolean} すべての要素が合格なら true を返す
 */
export function every (o, fn) {
  if (typeof o !== 'object') {
    return fn(o, '')
  }
  return everyObject('', o, fn)
}

/**
 * 値が空でないか検索する
 *
 * @param {*} value 値
 * @returns {Boolean} undefined, null, false, 0, 空文字 でなければ true
 */
export function notEmpty (value) {
  return !!value
}
